import axios from "../httpHandler";

export const IN_STOCK = 1;
export const OUT_OF_STOCK = 2;

export const getIngredients = async () => {
  try {
    const result = await axios.get(`input`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getUnits = async () => {
  try {
    const result = await axios.get(`unit`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getInputs = async () => {
  try {
    const result = await axios.get(`input`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getMe = async (token) => {
  try {
    const result = await axios.get(`user/me`, token && {
      headers: { Authorization: `Bearer ${token}` },
    });

    var unionData = null;
    const isUnion = parseInt(result?.data?.data?.user_type ?? 0) === 1;

    if (isUnion) {
      try {
        const unionResult = await axios.get(`union/me`, token && {
          headers: { Authorization: `Bearer ${token}` },
        });

        const union = unionResult?.data?.data;
        if (union) {
          unionData = { union_id: union.union_id, province_id: union.province_id };
        }
      } catch (error) { }
    }

    return { ...result?.data?.data, ...unionData };
  } catch (error) {
    console.log(error);
    throw error;
  }
};